exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".system-message[data-v-4c6ec3ed] {\n  font-size: 14px;\n  line-height: 20px;\n  margin-bottom: 10px;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n.system-message .content[data-v-4c6ec3ed] {\n  color: #ff42ff;\n}\n", ""]);

